import { useEffect, useState } from 'react';

import AppointmentsRepository from '@/repositories/AppointmentsRepository';

export const useWebJoinLink = () => {
  const [joinLink, setJoinLink] = useState<string | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [copiedJoinLink, setCopiedJoinLink] = useState(false);
  const appointmentsRepository = AppointmentsRepository();

  useEffect(() => {
    if (copiedJoinLink) {
      const timeout = setTimeout(() => setCopiedJoinLink(false), 2000);
      return () => clearTimeout(timeout);
    }
  }, [copiedJoinLink]);

  const fetchJoinLink = async (attendanceId: string) => {
    setIsLoading(true);
    setIsError(false);
    try {
      const link = await appointmentsRepository.getJoinLink(attendanceId);
      setJoinLink(link);
      await navigator.clipboard.writeText(link);
      setCopiedJoinLink(true);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    joinLink,
    isLoading,
    isError,
    copiedJoinLink,
    fetchJoinLink
  };
};
